import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "../v2/apiService";

export async function checkMessageCompliance(text, tier) {
  return await apiService.apiCall(
    endPoints.CHECK_MESSAGE_COMPLIANCE,
    "POST",
    { text, tier },
  );
}
